module.exports = __webpack_public_path__ + "img/playbutton24.c2a6afd7.png";